var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFork = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7 3v6a2 2 0 0 0 2 2v10M5 3v5a2 2 0 0 0 2 2m4-7v5a2 2 0 0 1-2 2m6-7c-1.5 1.5-2 3-2 5s.5 3 2 4v9"
})));
SvgFork.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgFork);
export default ForwardRef;